module.exports = __webpack_public_path__ + "img/cineflick-logo@3x.0b56a007.png";